import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { actions as groupActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { updateWithScheduledReset } from './withScheduledReset';

export const updateVariant = (paperId: string | undefined, sizeId: string | undefined, groupId: string) => {

    return (dispatch: PhotoPrintsPdpDispatch, getState: () => PhotoPrintsPdpState) => {

        const state = getState();
        const variants = selectAllVariants(state);

        const variant = variants.find(v => v!.sizeId === sizeId && v!.paperId === paperId);

        if (variant) {
            dispatch(groupActions.updateVariant({ variantId: variant.id, groupId: groupId }));
            dispatch(updateWithScheduledReset({ id: groupId, key: 'hasVariantUpdated', value: true }));
        }
    };
};